/* app/page/all */

define(
	'app/page/all',[
		'jquery',
		'app/ui/edgecompressioncalculator/edgecompressioncalculator',
		'app/ui/tooltip/tooltip',
		'util/lazyload',
		'app/ui/nav/load',
		'app/ui/track/load',
		'app/ui/rotator/rotator',
		'app/ui/rotator/home',
		'app/ui/expand-collapse/expand-collapse',
		'app/ui/video/video.player',
		'app/ui/social/share',
		'app/ui/map/map.load',
		'app/ui/form/form.umbraco',
		'app/ui/ajaxreplace/ajaxreplace',
		'app/ui/ticker/ticker',
		'app/ui/back-to-top/back-to-top',
		'app/ui/cookie/cookie',
		'app/ui/select-link/select-link',
		'app/ui/faq/faq',
		'app/ui/resources/resources',
		'app/ui/form/validate',
		'app/ui/modal/modal',
		'app/ui/filter/filter',
		'app/ui/sticky-subnav/sticky-subnav',
		'app/ui/tabbed-accordion/tabbed-accordion',
		'app/ui/tooltip/tooltip',

		'moment',
		'pikaday',
		'phatfingaz',
		'pubsub',
		'throttledebounce',
		'appendaround',
		'magnificPopup',
		'focus-visible',
		'iframeResizer'
	],
	function ($, EdgeCompression, Tooltip, LazyLoad, NavLoad, TrackLoad, Rotator, homeRotator, ExpandCollapse, VideoPlayer, SocialShare, MapLoad, UmbracoForms, AjaxReplace, Ticker, BackToTop, Cookie, selectLink, Faq, resources, formValidate, modal, filter, StickySubNav, moment, Pikaday) {

		'use strict';
		var $window = $(window);

		EdgeCompression.init();
		Tooltip.init();
		TrackLoad.init();
		NavLoad.init();
		LazyLoad.init();
		AjaxReplace.init();
		SocialShare.init();
		Cookie.init();
		selectLink.init();

		if (window.sjInitialised) {
			require(['//cdn.sajari.com/js/sj.js']);
		}

		// Publish Resize event
		var publishResizeEvent = function () {
			$.publish('/window/resize');
		};

		var publishScrollEvent = function () {
			$.publish('/window/scroll');
		};

		$('.js-hot').phatFingaz();

		// ExpandCollapse
		ExpandCollapse.init();

		// Faq
		Faq.init();

		// Resources
		resources.init();

		// Form Validation
		formValidate.init();

		// Video Macros
		VideoPlayer.init();

		filter.init();

		// Umbraco Forms
		// init function will load required dependencies if an umbraco form is present
		UmbracoForms.init();

		// Maps
		var $maps = $('.js-map');
		if ($maps.length) {
			MapLoad.init($maps);
		}

		// Rotators
		var $rotators = $('.js-rotator');
		if ($rotators.length) {
			Rotator.init($rotators);
		}
		var $homeRotator = $('.js-home-rotator');
		if ($homeRotator.length) {
			homeRotator.init();
		}

		// Modal
		modal.init({
			onShow: function ($modal) {
				$(window).trigger('/lazyload/resize');

				var $rotators = $modal.find('.js-rotator');
				var thisFlick;
				$rotators.each(function (i, el) {
					thisFlick = $(el).data('flickity-instance');

					if (thisFlick) {
						thisFlick.resize();
					}
				});
			}
		});

		// Ticker
		var $ticker = $('.js-statistics');
		if($ticker.length) {
			Ticker.init();
		}

		// Back to top
		if ($('.js-back-to-top').length) {
			BackToTop.init();
		}

		$window.on('resize', $.throttle(250, publishResizeEvent));
		$window.on('scroll', publishScrollEvent);

		var $datepickers = $('.js-datepicker');
		if ($datepickers.length) {
			$datepickers.each(function () {
				var $datepicker = $(this);

				if ($('.touchevents').length) {
					$datepicker.attr('readonly', 'readonly');
				}
				new Pikaday({ field: this, yearRange: 10 });
			});
		}

		// Language Dropdown
		var languagePicker = $('#language_chooser');
		var languageRedirect = function() {
			window.location.href = this.value;
		};

		languagePicker.appendAround();
		languagePicker.on('change', languageRedirect);


		// sticky sub nav 
		var $stickySubNav = $('.js-sub-navigation');

		if ($stickySubNav.length) {
			StickySubNav.init();
		}

		// Single and Multi Image Lightbox
		$('.js-lightbox-single').magnificPopup({
			delegate: '.js-lightbox-image',
			type: 'image'
		});

		$('.js-lightbox-gallery').each(function() {
			$(this).magnificPopup({
				delegate: '.js-lightbox-image',
				type: 'image',
				gallery: {
					enabled: true,
					navigateByImgClick: true,
					preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
				}
			});
		});

		//Video Group
		$(document).ready(function () {
			$('.js-video-group__item').magnificPopup({
				type: 'iframe',
			});
		});

		var supportsVideo = !!document.createElement('video').canPlayType;
		var heroVideo = document.getElementById('js-video-hero');

		if (supportsVideo && heroVideo !== null) {
			var playBtn = document.getElementById('js-video-hero__play');
			heroVideo.controls = false;

			playBtn.addEventListener('click', function(e) {
				if (heroVideo.paused || heroVideo.ended) {
					heroVideo.play();
					heroVideo.classList.add('now-playing');
					heroVideo.controls = true;
				} else {
					heroVideo.pause();
					heroVideo.classList.remove('now-playing');
					heroVideo.controls = false;
				}
			});
		}

		//responsive iframe
		if ($('.js-responsive-iframe').length) {
			var iframe = $('.js-responsive-iframe');
			// TODO: check ifame resize function after Forman add the iframeResizer.contentWindow.js inside iframe page
			iFrameResize({
				log: false,
				enablePublicMethods: true,
				heightCalculationMethod: 'bodyOffset',
				resizeFrom: 'parent',
				warningTimeout: 0,
                minHeight: 800,
                scrolling: true,
			}, ".js-responsive-iframe");
		}
	}
);
